// Testlab for testing API or plugins, to be removed when site goes live

jQuery(function ($) {
  if ($('.idea-indices-chart').length === 0) { return; }

  let resizeTimeout;
  let chartInterval;
  let startYear;
  let endYear;
  let totalSegments;
  let indicesData;

  // const gsodCid = $('#gsod-country-id').data('id');
  // Call API to get chart data
  const cid = $('#country-data').data('cid'); // Indices Country ID
  const nid = $('#country-data').data('nid'); // GSIDi site
  const baseUrl = $('#base-url').data('base-url');

  // GET /////////////////////////////////////////////
  const settings = {
    "url": baseUrl + "api/gsod-indices-data?country_id=" + cid + "&nid=" + nid,
    "method": "GET",
    "timeout": 0,
    "headers": {
      "Content-Type": "application/json"
    },
    error: function (error) {
      console.log('error', error);
    }
  };
  $.ajax(settings).done(function (response) {
    // console.log('response', JSON.parse(response));
    indicesData = JSON.parse(response);

    startYear = indicesData[0].past_data[0].label;
    endYear = indicesData[0].past_data[indicesData[0].past_data.length - 1].label;

    drawSidebarIndicesCharts();
    drawCharts();

    $('.loading-blocker.line-chart').fadeOut(1000, function () {
      $(this).remove();
    });
  });

  function drawCharts(showTooltip = false, coordinatesIndex = -1) {
    $('.idea-indices-chart').each(function (index) {
      const thisElm = $(this);

      const endValue = indicesData[index].past_data[indicesData[index].past_data.length - 1].value;

      thisElm.find('.indices-start-year').html(startYear);
      thisElm.find('.indices-end-year').html(endYear);
      thisElm.find('.latest-indice').html(endValue);

      let canvas = $(this).find('canvas')[0];
      let ctx = canvas.getContext("2d");
      let coordinates = [];

      canvas.width = canvas.getBoundingClientRect().width * 2;
      canvas.height = canvas.getBoundingClientRect().height * 2;

      const chartData = indicesData[index].past_data.map((d, i) => { return d.value; });

      function drawLineChart(showTooltip = false, coordinatesIndex = -1) {
        const cvWidth = canvas.width;
        const cvHeight = canvas.height;
        const sidePadding = 10;
        const chartTopLeft = 0 + sidePadding;
        const chartBottom = cvHeight - sidePadding;
        const chartWidth = cvWidth - (sidePadding * 2);
        const chartHeight = cvHeight - (sidePadding * 2);
        const minIndice = 0;
        const maxIndice = 1;
        const xInterval = chartWidth / (chartData.length - 1)

        ctx.clearRect(0, 0, cvWidth, cvHeight);

        ctx.strokeStyle = "#FFFFFF33";
        ctx.lineWidth = 3;

        // Draw the max value line
        ctx.beginPath();
        ctx.moveTo(chartTopLeft, chartTopLeft);
        ctx.lineTo(chartTopLeft + chartWidth, chartTopLeft);
        ctx.stroke();
        ctx.closePath();

        // Draw the min value line
        ctx.beginPath();
        ctx.moveTo(chartTopLeft, chartBottom);
        ctx.lineTo(chartTopLeft + chartWidth, chartBottom);
        ctx.stroke();
        ctx.closePath();

        ctx.setLineDash([15, 5]);

        // Draw 70% line (dash)
        ctx.beginPath();
        ctx.moveTo(chartTopLeft, chartTopLeft + (chartHeight * 0.3));
        ctx.lineTo(chartTopLeft + chartWidth, chartTopLeft + (chartHeight * 0.3));
        ctx.stroke();
        ctx.closePath();

        // Draw 40% line (dash)
        ctx.beginPath();
        ctx.moveTo(chartTopLeft, chartTopLeft + (chartHeight * 0.6));
        ctx.lineTo(chartTopLeft + chartWidth, chartTopLeft + (chartHeight * 0.6));
        ctx.stroke();
        ctx.closePath();

        ctx.lineWidth = 5;
        ctx.strokeStyle = "#2260DA";
        ctx.setLineDash([]);

        let x;
        let y;

        // Drawing the line
        x = 0 + sidePadding;
        y = Math.floor(parseFloat((maxIndice - chartData[0]) * chartHeight));

        let peak = 0;
        let peakCoordinate = { x: chartTopLeft + chartWidth, y: 0 };

        ctx.beginPath();
        ctx.moveTo(x, y);
        coordinates[0] = { x, y };

        for (i = 1; i < chartData.length; i++) {
          x += xInterval;
          y = Math.floor(parseFloat((maxIndice - chartData[i]) * chartHeight));
          ctx.lineTo(x, y);

          if (chartData[i] > peak) {
            peak = chartData[i];
            peakCoordinate.y = y;
          }

          coordinates[i] = { x, y };
        }

        ctx.stroke();
        ctx.closePath();

        // Drawing gradient tone under past data line chart //////////////////////////////////////////////
        let grd = ctx.createLinearGradient(cvWidth / 2, chartTopLeft, cvWidth / 2, chartBottom);
        grd.addColorStop(0, "#2260DA55");
        grd.addColorStop(1, "#2260DA00");

        x = 0 + sidePadding;
        y = Math.floor(parseFloat((maxIndice - chartData[0]) * chartHeight));

        ctx.beginPath();
        ctx.moveTo(x, chartBottom);
        ctx.lineTo(x, y);

        for (i = 1; i < chartData.length; i++) {
          x += xInterval;
          y = Math.floor(parseFloat((maxIndice - chartData[i]) * chartHeight));
          ctx.lineTo(x, y);
        }

        ctx.lineTo(x, chartBottom);
        ctx.closePath();

        ctx.fillStyle = grd;
        ctx.fill();

        // ctx.beginPath();
        // ctx.arc(peakCoordinate.x, peakCoordinate.y, 10, 0, 2 * Math.PI);
        // ctx.fillStyle = "#ff6600";
        // ctx.fill();
        // ctx.closePath();

        // Draw a dot on the line for tooltip position
        if (showTooltip) {
          ctx.beginPath();
          ctx.arc(coordinates[coordinatesIndex].x, coordinates[coordinatesIndex].y, 10, 0, 2 * Math.PI);
          ctx.fillStyle = "#2260DA";
          ctx.fill();
          ctx.closePath();
        }
      }

      drawLineChart();

      canvas.addEventListener('mousemove', function (e) {
        const rect = canvas.getBoundingClientRect();

        // * 2 because canvas is at 2x scale
        const mx = Math.floor((e.clientX - rect.left)) * 2;
        const my = Math.floor((e.clientY - rect.top)) * 2;

        let showTooltip = false;
        let coordinatesIndex;

        $.each(coordinates, function (index) {
          // x y of indices
          const x = $(this)[0].x;
          const y = $(this)[0].y;
          const distance = Math.sqrt(
            ((mx - x) * (mx - x))
            +
            ((my - y) * (my - y))
          );

          if (distance <= 15) {
            showTooltip = true;
            coordinatesIndex = index;
            renderTooltip(thisElm, startYear + coordinatesIndex, chartData[coordinatesIndex], (x / 2), (y / 2));
          }
        })

        if (showTooltip) {
          drawLineChart(true, coordinatesIndex);
        } else {
          drawLineChart();
          thisElm.parent().find('.line-chart-tooltip').remove();
        }

        // drawDot(cvW / 2, cvH / 2, mx, my);
      });

      canvas.addEventListener('mouseleave', function (e) {
        drawLineChart();
        thisElm.parent().find('.line-chart-tooltip').remove();
      });
    });
  }

  $(window).on('resize', function () {
    wWidth = $(window).width();

    clearTimeout(resizeTimeout);

    resizeTimeout = setTimeout(() => {
      drawSidebarIndicesCharts();
      drawCharts();
    }, 100);
  });

  function renderTooltip(elm, year, value, x, y) {
    if (elm.find('.line-chart-tooltip').length > 0) {
      elm.find('.line-chart-tooltip span.tooltip-year').text(year);
      elm.find('.line-chart-tooltip span.tooltip-value').text(addZeroAtTheEnd(value));
    } else {
      const html = '<div class="line-chart-tooltip ' +
        'absolute -translate-x-1/2 -translate-y-full pb-3 ' +
        'text-[#2D3246] ' +
        'pointer-events-none">' +
        '<div class="bg-white drop-shadow-tooltip font-aileron font-bold text-gsodBody text-xs whitespace-nowrap px-4 py-2">' +
        '<span class="tooltip-year">' + year + '</span> - <span class="tooltip-value">' + value + '</span>' +
        '</div>' +
        '</div>';

      elm.find('canvas').parent().append(html);
    }

    elm.find('.line-chart-tooltip').css('top', y + 'px');
    elm.find('.line-chart-tooltip').css('left', x + 'px');
  }

  function addZeroAtTheEnd(text) {
    // Make sure number is in 2 decimals
    if (text == "0") {
      return "0.00";
    } else if ((text + "").length < 4) {
      return text += "0";
    } else {
      return text;
    }
  }

  function drawSidebarIndicesCharts() {
    $('.sidebar-indices-data').each(function (index) {

      // Configure the start and end date for Sidebar
      const startDate = 2014;
      const endDate = 2023;

      const thisElm = $(this);
      let sideBarIndicesYears = [];
      const data = indicesData[index].past_data.map((d, i) => {
        if (d.label >= startDate && d.label <= endDate) {
          // Provide the years that meet the criteria into sideBarIndicesYears array
          sideBarIndicesYears.push(d.label);
          // console.log(d.value);
          return d.value;
        }
        return null; // Return null for values that don't meet the criteria
      }).filter((value) => value !== null); // Filters out the NULL values in the array returned from Mapping

      // console.log("sidebar", data);
      // Provide the starting year to the Sidebar Indices trend line tooltip
      sidebarIndicesPastDataStartYear = sideBarIndicesYears[0];

      let coordinates = [];

      // const data = [1, 1, 1, 1, 1, 0, 0.9, 0.3, 0.8, 0.2];

      let minIndice = Math.min(...data);
      let maxIndice = Math.max(...data);

      // const minIndice = 0;
      // const maxIndice = 1;

      let minMaxDiff = parseFloat(maxIndice - minIndice).toFixed(3);

      if (minMaxDiff <= 0.2) {
        maxIndice = parseFloat(minIndice + 0.2).toFixed(3);
      }

      const yAxisRange = (parseFloat(maxIndice - minIndice).toFixed(3) == 0.000 ? 1 : parseFloat(maxIndice - minIndice).toFixed(3));
      const canvasPadding = 20; // Canvas padding on all sides

      // console.log(minIndice + " / " + maxIndice  + " / " + yAxisRange);

      // Get value of last year
      let lastYearIndice = data[data.length - 1] + "";

      if (lastYearIndice == "0") {
        lastYearIndice = "0.00";
      } else if (lastYearIndice.length < 4) {
        lastYearIndice += "0";
      }

      thisElm.find('.last-year-indice').html(lastYearIndice + '&nbsp;<span class="text-xs">/1</span>');

      let canvas = thisElm.find('canvas')[0];
      let ctx = canvas.getContext('2d');

      canvas.width = canvas.getBoundingClientRect().width * 2;
      canvas.height = canvas.getBoundingClientRect().height * 2;

      const chartWidth = canvas.width - canvasPadding; // To have room on both sides
      const chartHeight = canvas.height - canvasPadding; // To have room on top and bottom

      function drawSidebarChart(showTooltip = false, coordinatesIndex = -1) {
        let x = 0;
        let y;

        const xInterval = chartWidth / (data.length - 1)

        ctx.clearRect(0, 0, canvas.width, canvas.height);

        // Drawing dots on data points
        x = 0 + (canvasPadding / 2);


        // This will draw Y axis base on min max value of indice data
        y = Math.floor(chartHeight - ((parseFloat((data[0] - minIndice).toFixed(3)) / yAxisRange) * chartHeight)) + (canvasPadding / 2);


        // Start drawing line
        x = 0 + (canvasPadding / 2);
        y = Math.floor(chartHeight - ((parseFloat((data[0] - minIndice).toFixed(3)) / yAxisRange) * chartHeight)) + (canvasPadding / 2);

        ctx.strokeStyle = "#2260DA";
        ctx.lineWidth = 4;
        ctx.beginPath();
        // Beginning of the line
        ctx.moveTo(x, y);

        coordinates[0] = { x, y };

        for (i = 1; i <= 9; i++) {
          x += xInterval;

          // This will draw Y axis base on min max value of indice data
          y = Math.floor(chartHeight - ((parseFloat((data[i] - minIndice).toFixed(3)) / yAxisRange) * chartHeight)) + (canvasPadding / 2);

          ctx.lineTo(x, y);
          coordinates[i] = { x, y };
        }

        ctx.stroke();
        ctx.closePath();

        if (showTooltip) {
          ctx.beginPath();
          ctx.arc(coordinates[coordinatesIndex].x, coordinates[coordinatesIndex].y, 10, 0, 2 * Math.PI);
          ctx.fillStyle = "#2260DA";
          ctx.fill();
          ctx.closePath();
        }
      }

      drawSidebarChart();

      canvas.addEventListener('mousemove', function (e) {
        const rect = canvas.getBoundingClientRect();

        // * 2 because canvas is at 2x scale
        const mx = Math.floor((e.clientX - rect.left)) * 2;
        const my = Math.floor((e.clientY - rect.top)) * 2;

        let showTooltip = false;
        let coordinatesIndex;

        $.each(coordinates, function (index) {
          // x y of indices
          const x = $(this)[0].x;
          const y = $(this)[0].y;
          const distance = Math.sqrt(
            ((mx - x) * (mx - x))
            +
            ((my - y) * (my - y))
          );

          if (distance <= 15) {
            showTooltip = true;
            coordinatesIndex = index;
            renderTooltip(thisElm, sidebarIndicesPastDataStartYear + coordinatesIndex, data[coordinatesIndex], (x / 2), (y / 2));
          }
        })

        if (showTooltip) {
          drawSidebarChart(true, coordinatesIndex);
        } else {
          drawSidebarChart();
          thisElm.find('.line-chart-tooltip').remove();
        }
      });

      canvas.addEventListener('mouseleave', function (e) {
        drawSidebarChart();
        thisElm.find('.line-chart-tooltip').remove();
      });
    });
  }

  // function convertDivToImage() {
  //   const targetDiv = document.getElementById('indices-chart-RG');

  //   // Use html2canvas library to capture the content of the div as an image
  //   html2canvas(targetDiv).then(canvas => {
  //     // Convert the canvas image to base64 format
  //     const imageBase64 = canvas.toDataURL('image/png'); // You can change 'image/png' to other image formats if needed

  //     // Display the base64 image data
  //     console.log(imageBase64);
  //   });
  // }

});
